import { faHandPointRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Zoom } from 'react-reveal';
import swal from 'sweetalert';


const BookStoreCart = ({ books }) => {
    const { bookName, bookPhoto, price, writter } = books;



    const handleBuyBook = () => {
        swal("দুঃখিত!", "এখানে কোন পেমেন্ট গেটওয়ে যোগ করা হয়নি এটা শুধুমাত্র শেখার কাজে ব্যবহার করা হয়েছে!", "error");
    }

    return (
        <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
            <Zoom>
                <div className="shadow-lg">
                    <img src={bookPhoto} alt={bookName} className='img-fluid mb-3 d-block mx-auto rounded' style={{ height: '310px' }} />
                    <div className="book-info text-center">
                        <h4 className='fw-bold'>{bookName}</h4>
                        <h6 className='mt-1 mb-1 text-secondary'>{writter}</h6>
                        <p className='fw-bold fs-4 text-success'><span className='fs-2 me-1'>৳</span>{price}</p>
                    </div>
                    <div className="btn btn-primary w-100 d-block fs-5" onClick={handleBuyBook}>বইটি কিনুন  <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></div>
                </div>
           </Zoom>
        </div>
    );
};

export default BookStoreCart;